module.exports = __webpack_public_path__ + "static/home-cf3e490c94a155133352fd7c823e7b72.svg";